<template>
  <div class="page">
    <div class="box">
      <div class="aside">
        <div class="top" style="margin-right: 20px">
          <span style="padding-right: 10px">发送状态</span>
          <el-select v-model="value" placeholder="请选择" @change="change">
            <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value" placeholder="全部"></el-option>
          </el-select>
        </div>
        <div class="top">
          <span>选择时间：</span>
          <el-date-picker @change="timechange" v-model="value2" value-format="timestamp" type="datetimerange" :picker-options="pickerOptions" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" align="right"></el-date-picker>
        </div>
      </div>
      <el-table :data="tableData" border style="width: 100%" :cell-style="{ 'text-align': 'center' }" :header-cell-style="{
          background: '#f5f7fa',
          color: '#606266',
          'text-align': 'center',
        }">
        <el-table-column prop="alias_name" label="姓名" width="200"></el-table-column>
        <el-table-column label="支付类型" width="200">
          <template slot-scope="scope">
            <span v-show="tableData[scope.$index].type == 1">直接收款</span>
            <span v-show="tableData[scope.$index].type == 2">文件收款</span>
          </template>
        </el-table-column>
        <el-table-column prop="money" label="支付金额" width="200"></el-table-column>
        <el-table-column prop="created_at" label="发送时间" width="200"></el-table-column>
        <el-table-column label="状态" width="200">
          <template slot-scope="scope">
            <span v-show="tableData[scope.$index].status == 1">收款中</span>
            <span v-show="tableData[scope.$index].status == 2">收款成功</span>
            <span v-show="tableData[scope.$index].status == 3">收款失败</span>
          </template>
        </el-table-column>
        <el-table-column prop="address" label="操作">
          <template slot-scope="scope">
            <div style="display: flex; flex-direction: column; align-items: center">
              <span style="color: #96a9e9" @click="detail(scope.$index)">详情</span>
              <span style="padding: 10px 0; color: #96a9e9" v-show="tableData[scope.$index].status == 1" @click="adopt(scope.$index)">确认收款</span>
              <span style="color: #96a9e9" v-show="tableData[scope.$index].status == 1" @click="jujue(scope.$index)">拒绝收款</span>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div class="block">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentpage" :page-size="pagesize" layout="total, prev, pager, next, jumper" :total="total"></el-pagination>
      </div>

      <el-dialog title="收款详情" :visible.sync="centerDialogVisible" width="30%" center>
        <div style="margin-left: 20px">
          <div>
            <span style="padding-right: 10px">收款金额</span>
            <span style="color: red">
              ￥
              <span style="font-size: 15px">{{ detaildata.money }}</span>
            </span>
          </div>
          <div style="margin: 10px 0">
            <span style="padding-right: 10px">收款方式</span>
            <span v-show="detaildata.type == 1">直接付款</span>
            <span v-show="detaildata.type == 2">文件付款</span>
          </div>
          <div class="detailsty" v-show="detaildata.type == 2">
            <div class="detailsty_child">
              <img src="/img/合同图标.png" />
              <span style="padding-left: 5px">附件</span>
            </div>
            <a :href="detaildata.file_url" download>下载</a>
          </div>
          <div>
            <span style="padding-right: 10px">收款时间</span>
            <span>{{ detaildata.created_at }}</span>
          </div>
          <div>
            <span style="padding-right: 10px">收款项目</span>
            <span>{{ detaildata.name }}</span>
          </div>
          <div>
            <span style="padding-right: 10px">付款人员</span>
            <span>{{ detaildata.alias_name }}</span>
          </div>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="centerDialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="centerDialogVisible = false">确 定</el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import {
  dealexternalList,
  dealexternalInfo,
  externalmoniadd,
} from "@/api/login/login";
export default {
  data () {
    return {
      value2: "",
      timestart: "",
      timeend: "",
      i: 0,
      pagesize: 5,
      currentpage: 1,
      tableData: [],
      total: -1,
      value: "",
      options: [
        {
          value: "0",
          label: "全部",
        },
        {
          value: "1",
          label: "收款中",
        },
        {
          value: "2",
          label: "收款完成",
        },
        {
          value: "3",
          label: "取消",
        },
      ],
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick (picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick (picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
      centerDialogVisible: false,
      detaildata: {},
    };
  },
  mounted () {
    this.getlist();
  },
  methods: {
    jujue (index) {
      let data = {
        id: this.tableData[index].id,
        status: 3,
        mark: "拒绝",
      };
      externalmoniadd(data).then((res) => {
        if (res.code == 200) {
          this.$message({
            type: "success",
            message: "拒绝成功",
          });
          this.getlist();
        } else {
          this.$message({
            type: "success",
            message: res.msg,
          });
        }
      });
    },
    //同意
    adopt (index) {
      let data = {
        id: this.tableData[index].id,
        status: 2,
      };
      externalmoniadd(data).then((res) => {
        if (res.code == 200) {
          this.$message({
            type: "success",
            message: "成功",
          });
          this.getlist();
        } else {
          this.$message({
            type: "warning",
            message: res.msg,
          });
        }
      });
    },
    //充值记录分页
    handleSizeChange (val) {
      this.pagesize = val;
      this.getlist();
    },
    handleCurrentChange (val) {
      this.currentpage = val;
      if (this.i == 0) {
        this.getlist();
      } else {
        let data = {
          limit: this.pagesize,
          page: this.currentpage,
          status: this.i,
        };
        dealexternalList(data).then((res) => {
          this.tableData = res.data.data;
          this.total = res.data.total;
        });
      }
    },
    //选择时间
    timechange (e) {
      this.timestart = e[0] / 1000;
      this.timeend = e[1] / 1000;
    },
    //收款记录
    getlist () {
      let data = {
        limit: this.pagesize,
        page: this.currentpage,
      };
      dealexternalList(data).then((res) => {
        this.tableData = res.data.data;
        this.total = res.data.total;
      });
    },
    //详情
    detail (index) {
      this.ids = index;
      this.centerDialogVisible = true;
      let data = {
        id: this.tableData[index].id,
      };
      dealexternalInfo(data).then((res) => {
        this.detaildata = res.data;
      });
    },
    //选择发送状态
    change (e) {
      this.i = e;
      if (e == 0) {
        this.getlist();
      } else {
        let data = {
          limit: this.pagesize,
          page: this.currentpage,
          status: e,
        };
        dealexternalList(data).then((res) => {
          this.tableData = res.data.data;
          this.total = res.data.total;
        });
      }
    },
  },
  components: {},
};
</script>

<style lang='scss' scoped>
.page {
  .detailsty {
    .detailsty_child {
      display: flex;
      align-items: center;
      img {
        width: 25px;
        height: 25px;
      }
    }
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 7px;
    border: 1px #ccc solid;
    width: 200px;
    height: 30px;
    border-radius: 7px;
  }
  height: auto !important;
  .box {
    height: 600px;
    overflow-y: scroll;
    overflow-x: hidden;
    margin-bottom: 40px;
  }
  .aside {
    display: flex;
    align-items: center;
    margin: 20px 0;
    .top {
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }
  .block {
    display: flex;
    justify-content: center;
    margin-top: 100px;
    padding-bottom: 10px;
  }
}
</style>
